<template>
  <div class="absolute left-0 bottom-0 top-0 pa4 flex flex-column justify-end">
    <NavSidebar
      ref="navSidebar"
      v-if="navigation"
      :brand="brand"
      :items="navigation"
      :title="title"
    />
    <div>
      <Button
        :brand="brand"
        :icon="icon.arrowUp"
        text="Back to top"
        @click="backToTop"
      />
    </div>
  </div>
</template>

<script>
import Button from '@/components/Button'
import NavSidebar from '@/components/NavSidebar'

export default {
  name: 'Sidebar',
  components: {
    Button,
    NavSidebar
  },
  props: {
    brand: {
      type: String,
      default: 'lh'
    },
    navigation: {
      type: Array,
      default: null
    },
    title: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      icon: {
        arrowUp: require('@/assets/img/arrow-left-circle.svg')
      }
    }
  },
  methods: {
    reset () {
      this.$store.commit('setSidebarNav', -1)
      setTimeout(() => {
        this.$store.commit('setActiveTab', 0)
      }, 500)
    },
    backToTop () {
      this.$refs.navSidebar.resetTabs()
      this.reset()
      this.$router.push('/developments/' + this.$route.params.development + '/' + this.$route.params.plot)
    }
  }
}
</script>
